export default __webpack_public_path__ + "static/media/28_WL.ed3e3adc.png";